import React, { FC, useCallback } from 'react';

import { ArrowLeftIcon } from '@motorway/mw-highway-code';

import {
  REVIEW_BODY_MAX_LENGTH,
  REVIEW_TITLE_MAX_LENGTH,
} from 'Utilities/helpers';

import { LoadingArrow } from 'Storybook/components/local/LoadingArrow/LoadingArrow';

import { TrustpilotApiReview, TrustpilotBrand } from '../trustpilotCommon/Trustpilot.types';
import { TrustpilotCommonCarousel } from '../trustpilotCommon/TrustpilotCommonCarousel';

import { TrustpilotCardBespoke } from './TrustpilotCardBespoke';

import styles from './TrustpilotCarouselBespoke.scss';

type TrustpilotCarouselBespokeProps = {
  brand?: TrustpilotBrand;
  cardTitleTruncationLength?: number;
  cardTruncationLength?: number;
  loaded?: boolean;
  reviews: TrustpilotApiReview[];
};

export const TrustpilotCarouselBespoke: FC<TrustpilotCarouselBespokeProps> = ({
  brand,
  cardTitleTruncationLength = REVIEW_TITLE_MAX_LENGTH,
  cardTruncationLength = REVIEW_BODY_MAX_LENGTH,
  loaded = false,
  reviews,
}) => {
  const generateBreakPointConfig = useCallback((breakpoints: Record<string, boolean>) => {
    const slidesNum = [
      {
        breakpoint: 'breakpointMobile',
        slides: 1,
      },
      {
        breakpoint: 'breakpointTabletMobile',
        slides: 2,
      },
      {
        breakpoint: 'breakpointTablet',
        slides: 3,
      },
    ].find(({ breakpoint }) => breakpoints[breakpoint])?.slides || 4;

    return {
      allowTouchMove: breakpoints.breakpointTablet,
      slidesPerGroup: slidesNum,
      slidesPerView: slidesNum,
      spaceBetween: 24,
      speed: 1000,
    };
  }, []);

  if (!loaded) {
    return (
      <div className={styles.loading}>
        <LoadingArrow />
      </div>
    );
  }

  return (
    <TrustpilotCommonCarousel
      {...{
        brand,
        cardTitleTruncationLength,
        cardTruncationLength,
        generateBreakPointConfig,
        loaded,
        minReviews: 1,
        PrevNextComponent: ArrowLeftIcon,
        reviews,
        styles,
        TrustpilotCardComponent: TrustpilotCardBespoke,
      }}
    />
  );
};
